exports.defaultSettings = {
  navigationType: 'hover', // -- "hover" or "scroller" or "thumbsAndArrows",
  menuPosition: 'bottom',
  navigation_direction: 'auto', // -- "auto" or "vertical" or "horizontal"
  menuItemWidth: 'default', // -- number or "default"
  menuItemHeight: 'default',
  isAutoScrollToCurrent: false,
  isSyncMainAreaAndNavigatinoAreas: true,
  isUseEasing: true,
}
